// src/services/news.ts
import { apiJson } from './http';

export type Page<T> = {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number; // page index
  size: number;   // page size
};

export type NewsDTO = {
  id: number;
  title: string;
  content?: string | null;
  imageUrl?: string | null;
  author: string;
  isPublished: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
};

/* ----------------- CRUD News (PRIVATE /p/news) ----------------- */

export async function listNews(params?: { page?: number; size?: number }) {
  const page = params?.page ?? 0;
  const size = params?.size ?? 12;
  const qs = new URLSearchParams({ page: String(page), size: String(size) });
  return apiJson<Page<NewsDTO>>(`/p/news?${qs.toString()}`);
}

export async function getNews(id: number): Promise<NewsDTO> {
  return apiJson<NewsDTO>(`/p/news/${id}`);
}

export async function createNews(payload: Omit<NewsDTO, 'id' | 'createdAt' | 'updatedAt'>): Promise<NewsDTO> {
  return apiJson<NewsDTO>('/p/news', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateNews(id: number, patch: Partial<Omit<NewsDTO, 'id'>>) {
  return apiJson<NewsDTO>(`/p/news/${id}`, {
    method: 'PUT',
    body: JSON.stringify(patch),
  });
}

export async function deleteNews(id: number): Promise<void> {
  await apiJson<void>(`/p/news/${id}`, { method: 'DELETE' });
}
